import * as constant from "../constants/config";
import { isAssignedToParticipantSite, isUserAllowed } from "@/routes/hooks";
import { toastr } from "../setup";

const checkIfUserAllowed = async (to, from, next) => {
  try {
    await isUserAllowed({ studyId: to.params.studyId });
    next();
  } catch (error) {
    toastr.error(error.message);
    next(false);
  }
};

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../components/auth/login"),
    meta: {
      rule: "*"
    }
  },
  {
    path: "/forgot-password",
    name: "forgotPassword",
    component: () => import("../components/auth/forgot-password"),
    meta: {
      rule: "*"
    }
  },
  {
    path: "/forgot-password-via-username",
    name: "forgot-password-via-username",
    component: () => import("../components/auth/forgot-password-by-username"),
    meta: {
      rule: "*"
    }
  },
  {
    path: "/forgot-username",
    name: "forgot-username",
    component: () => import("../components/auth/forgot-username"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "aboutYou",
    path: "/about-you/:userId",
    component: () => import("../components/auth/about-you"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "resetPassword",
    path: "/reset-password/:token",
    component: () => import("../components/auth/reset-password"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "createPassword",
    path: "/create-password/:token",
    component: () => import("../components/auth/create-password"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "create-password-aws",
    path: "/create-password-aws/:username/:pwdChngInitByAdmin?",
    component: () => import("../components/auth/create-password-aws"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "complete-registration",
    path: "/register/:token",
    component: () => import("../components/auth/complete-registration"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "create-username",
    path: "/create-username/:token",
    component: () => import("../components/auth/create-username"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "get-create-username-link",
    path: "/get-create-username-link",
    component: () => import("../components/auth/get-create-username-link"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "dont-have-username",
    path: "/dont-have-username",
    component: () => import("../components/auth/dont-have-username"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "expire-link",
    path: "/expire-link",
    component: () => import("../components/auth/expire-link"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "forgot-password-otp",
    path: "/forgot-password-otp/:token/:mobile?",
    component: () => import("../components/auth/send-otp"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "reset-password-otp",
    path: "/reset-password-send-otp/:token/:mobile?",
    component: () => import("../components/auth/reset-password-send-otp"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "verify-identity",
    path: "/verify-identity/:token/:mobile?",
    component: () => import("../components/auth/verify-identity-with-otp"),
    meta: {
      rule: "*"
    }
  },
  {
    path: "/policy",
    name: "privacy-policy",
    component: () => import("../components/common/privacy-policy"),
    meta: {
      rule: "*"
    }
  },
  {
    path: "/terms-of-use",
    name: "terms-of-use",
    component: () => import("../components/common/terms-of-use"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "clients",
    path: "/clients",
    component: () => import("../components/clients/clients"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "activity library",
    path: "/activity-library",
    component: () => import("../pages/activity-configurator/activity-library"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "activity-library-homepage",
        path: "",
        component: () => import("../pages/activity-configurator/activity-library-homepage")
      },
      {
        name: "study-activities-activity-library",
        path: "study-activities/studies/:studyId",
        component: () => import("../pages/activity-configurator/activity-library-homepage")
      },
      {
        name: "data-capture-form-activity-library",
        path: "data-capture-form/studies/:studyId",
        component: () => import("../pages/activity-configurator/activity-library-homepage")
      },
      {
        name: "study-activities-activity-details",
        path: "study-activities/studies/:studyId/activities/:activityId",
        component: () => import("../components/activity-library/activity-create"),
        props: true,
        rule: "*"
      },
      {
        name: "data-capture-form-activity-details",
        path: "data-capture-form/studies/:studyId/activities/:activityId",
        component: () => import("../components/activity-library/activity-create"),
        props: true,
        rule: "*"
      },
      {
        name: "data-capture-form-activity-questions",
        path: "data-capture-form/studies/:studyId/activities/:activityId/questions",
        component: () => import("../components/activity-library/activity-questions"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-advanced-scoring",
        path: "activities/:activityId/activity-advanced-scoring",
        component: () => import("../components/activity-library/activity-advanced-scoring")
      },
      {
        name: "study-activities-activity-questions",
        path: "study-activities/studies/:studyId/activities/:activityId/questions",
        component: () => import("../components/activity-library/activity-questions"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activity-activity-review",
        path: "study-activity/studies/:studyId/activities/:activityId/review",
        component: () => import("../components/activity-library/activity-review"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "data-capture-form-activity-review",
        path: "data-capture-form/studies/:studyId/activities/:activityId/review",
        component: () => import("../components/activity-library/activity-review"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activities-activity-export",
        path: "study-activities/studies/:studyId/activities/:activityId/export",
        component: () => import("../components/activity-library/activity-export"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "data-capture-form-activity-export",
        path: "data-capture-form/studies/:studyId/activities/:activityId/export",
        component: () => import("../components/activity-library/activity-export"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-library-manage-tags",
        path: "tags",
        component: () => import("../pages/activity-configurator/manage-tags")
      },
      {
        name: "activity-library-manage-groups",
        path: "groups",
        component: () => import("../pages/activity-configurator/manage-groups")
      },
      {
        name: "activity-details",
        path: "activities/:activityId",
        component: () => import("../components/activity-library/activity-create"),
        props: true,
        rule: "*"
      },
      {
        name: "activity-questions",
        path: "activities/:activityId/questions",
        component: () => import("../components/activity-library/activity-questions"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-review",
        path: "activities/:activityId/review",
        component: () => import("../components/activity-library/activity-review"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-export",
        path: "activities/:activityId/export",
        component: () => import("../components/activity-library/activity-export"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-library-archived-activities",
        path: "archive",
        component: () => import("../pages/activity-configurator/archived-activities"),
        props: true,
        meta: {
          rule: "*"
        }
      }
    ]
  },
  {
    name: "client-list",
    path: "/client-list/:clientId",
    component: () => import("../components/clients/client-list"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "add-new-client-member",
    path: "/:clientId/add-new-client-member/:clientMemberId",
    component: () => import("../components/clients/add-new-client-member"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "add-edit-client-member",
    path: "/:clientId/add-edit-client-member/:clientMemberId",
    component: () => import("../components/clients/add-edit-client-member"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "add-edit-client",
    path: "/add-edit-client/:clientId",
    component: () => import("../components/clients/add-edit-client"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "client-added",
    path: "/client-added",
    component: () => import("../components/clients/client-added"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "studies",
    path: "/studies",
    component: () => import("../components/studies/studies"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "dashboard",
    path: "/studies/:studyId/dashboard",
    component: function() {
      if (constant.SCREENWIDTH > 767) {
        return import("../components/dashboard/dashboard");
      } else {
        return import("../components/dashboard/dashboard_mobile");
      }
    },
    beforeEnter: checkIfUserAllowed,
    meta: {
      rule: "*"
    }
  },
  {
    name: "notification-list",
    path: "/studies/:studyId/notification-list",
    component: () => import("../components/notifications/notification-list"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "preview-page",
    path: "/studies/:studyId/previewpage",
    component: () => import("../components/participantweb/preview-page"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "publish-page",
    path: "/studies/:studyId/publish",
    component: () => import("../components/participantweb/publish-page"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "analytics",
    path: "/studies/:studyId/vis",
    component: () => import("../components/visualization"),
    redirect: "/studies/:studyId/vis/study-executive",
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "vis-enrollment",
        path: "enrollment",
        component: () => import("../components/visualization/recruitment"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "vis-data-management",
        path: "data-management",
        component: () => import("../components/visualization/data-management"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-study-compliance",
        path: "study-compliance",
        component: () => import("../components/visualization/study-compliance"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-study-engagement",
        path: "study-engagement",
        component: () => import("../components/visualization/study-engagement"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-participant-status",
        path: "participant-status",
        component: () => import("../components/visualization/participant-status"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-withdrawal",
        path: "withdrawal",
        component: () => import("../components/visualization/withdrawal"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-participant-completion",
        path: "participant-completion",
        component: () => import("../components/visualization/participant-completion"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-datapoints",
        path: "datapoints",
        component: () => import("../components/visualization/datapoints"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-data-queries",
        path: "data-queries",
        component: () => import("../components/visualization/data-queries"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-compliance",
        path: "compliance",
        component: () => import("../components/visualization/compliance"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-study-executive",
        path: "study-executive",
        component: () => import("../components/visualization/study-executive"),
        beforeEnter: checkIfUserAllowed,
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-study-completion",
        path: "study-completion",
        component: () => import("../components/visualization/study-completion"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "vis-participant-focus",
        path: "participant-focus",
        component: () => import("../components/visualization/participant-focus"),
        meta: {
          rule: "*"
        },
        props: true
      }
    ]
  },
  {
    name: "study-details",
    path: "/studies/:studyId/study-details",
    component: () => import("../pages/study-details"),
    beforeEnter: checkIfUserAllowed,
    meta: {
      rule: "*"
    }
  },
  {
    path: "/studies/:studyId/telehealth",
    component: () => import("../components/tele-health-sp/tele-health"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "telehealth-appointments",
        path: "",
        component: () => import("../components/tele-health-sp/appointments"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "telehealth-availability",
        path: "availability",
        component: () => import("../components/tele-health-sp/availability"),
        meta: {
          rule: "*"
        }
      }
    ]
  },
  {
    name: "research-team",
    path: "/studies/:studyId/research-team",
    component: () => import("../pages/research-team"),
    meta: {
      permission: "auth"
    },
    children: [
      {
        name: "study-admins",
        path: "",
        component: () => import("../components/research-team/study-admins"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "study-team",
        path: "study-team",
        component: () => import("../components/research-team/study-team"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "study-team-notifications",
        path: "study-team/notification-settings",
        component: () => import("../components/common/notification-settings"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "research-site",
        path: "research-site",
        component: () => import("../components/research-team/research-site"),
        meta: {
          permission: "auth"
        },
        props: true,
        children: [
          {
            name: "list-research-site",
            path: "",
            component: () => import("../components/research-team/list-research-site"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "add-research-site",
            path: "create",
            component: () => import("../components/research-team/add-research-site"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "research-site-notifications",
            path: "notification-settings",
            component: () => import("../components/common/notification-settings"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "research-site-details",
            path: ":siteId/view",
            component: () => import("../components/research-team/research-site-details"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "add-research-site-documents",
            path: ":siteId/add-research-site-documents",
            component: () => import("../components/research-team/add-research-site-document"),
            meta: {
              permission: "auth"
            },
            props: true
          }
        ]
      }
    ]
  },
  {
    name: "site-team",
    path: "/studies/:studyId/site-team",
    component: () => import("../pages/site-team"),
    beforeEnter: checkIfUserAllowed,
    meta: {
      permission: "auth"
    },
    children: [
      {
        name: "site-details",
        path: ":siteId/view",
        component: () => import("../components/research-team/research-site-details"),
        meta: {
          permission: "auth"
        },
        props: true
      }
    ]
  },
  {
    name: "epros-summary",
    path: "/studies/:studyId/study-details/epros/:eproId",
    component: () => import("../components/study-details/view-links/epros.vue"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "edros-summary",
    path: "/studies/:studyId/study-details/edros/:edroId",
    component: () => import("../components/study-details/view-links/edros.vue"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "survey-summary",
    path: "/studies/:studyId/study-details/survey/:surveyId",
    component: () => import("../components/study-details/view-links/surveys.vue"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "activity-summary",
    path: "/studies/:studyId/study-details/activity/:activityId",
    component: () => import("../components/study-details/view-links/activity.vue"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "data-capture-form",
    path: "/studies/:studyId/data-capture-form",
    component: () => import("../pages/data-capture/data-capture-forms"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "forms-list",
        path: "",
        component: () => import("../components/edc-form/forms-list"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "set-notification",
        path: "notification-settings/:formId",
        component: () => import("../components/edc-form/notification-settings"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "form-view",
        path: "form-view/:formId",
        component: () => import("../components/edc-form/form-view.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-form-view",
        path: "activity-form-view/:formId",
        component: () => import("../components/activity-form/activity-form-view.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "form-versions",
        path: "form-versions/:formId",
        component: () => import("../components/edc-form/form-versions.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-form-versions",
        path: "activity-form-versions/:formId",
        component: () => import("../components/activity-form/activity-form-versions.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "schedule-form",
        path: "schedule-form/:formId",
        component: () => import("../components/edc-form/schedule-form"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "schedule-packet",
        path: "schedule-packet/:packetId",
        component: () => import("../components/edc-form/schedule-packet"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "unschedule-forms",
        path: "unschedule-forms/:packetId",
        component: () => import("../components/edc-form/unscheduled-forms"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "create-edit-packet",
        path: "packet/:packetId",
        component: () => import("../components/edc-form/create-packet"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "show-packet",
        path: "show-packet",
        component: () => import("../components/edc-form/show-packet"),
        meta: {
          rule: "*"
        }
      }
    ]
  },
  {
    name: "configure-new-form",
    path: "/studies/:studyId/configure-new-form/:formId",
    component: () => import("../components/edc-form/configure-new-form"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "launch",
    path: "/studies/:studyId/launch",
    component: () => import("../components/configurator/launch/launch"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "manage",
    path: "/studies/:studyId/manage",
    component: () => import("../components/configurator/manage/manage"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "invite-admins",
    path: "/invite-admins",
    component: () => import("../components/invite-admins/invite-admins"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "epro-preview",
    path: "/studies/:studyId/epro/:eproId/preview",
    component: () => import("../components/epros/epro-details"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "read-only-questions",
    path: "/read-only-questions",
    component: () => import("../components/common/read-only-questions"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "users",
    path: "/users",
    component: () => import("../components/users/users"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "users-deactivation-settings",
    path: "/users/deactivation-settings",
    component: () => import("../components/users/user-deactivation-settings"),
    meta: {
      permission: "auth"
    },
    props: true
  },
  {
    name: "add-edit-user",
    path: "/users/:userId",
    component: () => import("../components/users/add-edit-user"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "sponsers",
    path: "/sponsers",
    component: () => import("../components/sponsers/sponsers"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "sponsers-list",
    path: "/sponsers-list/:sponserId",
    component: () => import("../components/sponsers/sponsers-list"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "sponser-member-add-edit",
    path: "/sponser-member-add-edit/:sponserId",
    component: () => import("../components/sponsers/sponser-member-add-edit"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "sponser-member-add-new",
    path: "/sponser-member-add-new/:sponserId",
    component: () => import("../components/sponsers/sponser-member-add-new"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "add-edit-sponser",
    path: "/add-edit-sponser/:sponserId",
    component: () => import("../components/sponsers/add-edit-sponser"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "sponser-added",
    path: "/sponser-added",
    component: () => import("../components/sponsers/sponser-added"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "profile",
    path: "/profile/:id",
    component: () => import("../components/profile/profile"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "sso-settings",
    path: "/sso-settings",
    component: () => import("../components/sso-login/sso-idp-list"),
    meta: {
      rule: "*"
    }
  },
  {
    path: "/studies/:studyId/web",
    component: () => import("../pages/web"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "global",
        path: "global",
        component: () => import("../components/participantweb/global-elements"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "homepage",
        path: "homepage",
        component: () => import("../components/participantweb/homepage"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "eligibility-screening",
        path: "eligibility-screening",
        component: () => import("../components/participantweb/eligibility"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "agreement",
        path: "agreement",
        component: () => import("../components/participantweb/agreement"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "register",
        path: "register",
        component: () => import("../components/participantweb/registration"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "publish",
        path: "publish",
        component: () => import("../components/participantweb/publish-page"),
        meta: {
          rule: "*"
        },
        props: true
      }
    ]
  },
  {
    path: "/studies/:studyId/participants",
    component: () => import("../pages/study-participants"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "study-participants-list",
        path: "list",
        component: function() {
          if (constant.SCREENWIDTH > 767) {
            return import("../components/participants/participants-list");
          } else {
            return import("../components/participants/participants-list-mobile");
          }
        },
        beforeEnter: checkIfUserAllowed,
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participant-document",
        path: ":participantId/documents/:documentId",
        component: () => import("../components/participants/documents/participant-document-detail"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participant-document-history",
        path: ":participantId/documents/:documentId",
        component: () => import("../components/participants/documents/document-details-history"),
        meta: {
          rule: "*"
        },
        props: true,
        children: [
          {
            name: "document-details",
            path: "details",
            component: () => import("../components/participants/documents/document-details"),
            meta: {
              rule: "*"
            },
            props: true
          },
          {
            name: "document-history",
            path: "history",
            component: () => import("../components/participants/documents/document-history"),
            meta: {
              rule: "*"
            },
            props: true
          }
        ]
      },
      {
        name: "study-participants-data-dashboard",
        path: "data-dashboard",
        component: () => import("../pages/study-participants/study-participants-data-dashboard"),
        meta: {
          rule: "*"
        },
        children: [
          {
            name: "study-admins",
            path: "",
            component: () => import("../components/research-team/study-admins"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "study-team",
            path: "study-team",
            component: () => import("../components/research-team/study-team"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "research-site",
            path: "research-site",
            component: () => import("../components/research-team/research-site"),
            meta: {
              permission: "auth"
            },
            props: true,
            children: [
              {
                name: "list-research-site",
                path: "",
                component: () => import("../components/research-team/list-research-site"),
                meta: {
                  permission: "auth"
                },
                props: true
              },
              {
                name: "add-research-site",
                path: "create",
                component: () => import("../components/research-team/add-research-site"),
                meta: {
                  permission: "auth"
                },
                props: true
              },
              {
                name: "research-site-details",
                path: ":siteId/view",
                component: () => import("../components/research-team/research-site-details"),
                meta: {
                  permission: "auth"
                },
                props: true
              },
              {
                name: "add-research-site-documents",
                path: ":siteId/add-research-site-documents",
                component: () => import("../components/research-team/add-research-site-document"),
                meta: {
                  permission: "auth"
                },
                props: true
              }
            ]
          }
        ],
        props: true
      },
      {
        name: "study-participants-edc-data-dashboard",
        path: "edc-data-dashboard",
        component: () => import("../pages/study-participants/study-participants-edc-data-dashboard"),
        beforeEnter: checkIfUserAllowed,
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-documents",
        path: "study-participant-documents",
        component: () => import("../pages/study-participants/study-participant-documents"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "configure-document",
        path: "configure-document/:documentId",
        component: () => import("../pages/study-participants/study-participant-configure-document"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-messages",
        path: "messages",
        component: () => import("../pages/study-participants/study-participant-messages"),
        meta: {
          rule: "*"
        },
        props: true
      },
      /* New visits component */
      {
        name: "study-participant-appointments",
        path: "visits",
        component: () => import("../components/tele-health-sp/appointments-new"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-availability",
        path: "availability",
        component: () => import("../components/tele-health-sp/availability"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-compose-message",
        path: "messages/compose/:composeMessageId",
        component: () => import("../pages/study-participants/study-participant-compose-message"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-details",
        path: ":participantId",
        component: () => import("../pages/study-participants/study-participant-details"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participant-profile",
        path: ":participantId/participant-profile",
        component: function() {
          if (constant.SCREENWIDTH > 767) {
            return import("../pages/study-participants/study-participants-details-new");
          } else {
            return import("../pages/study-participants/study-participants-details-new-mobile");
          }
        },
        beforeEnter: async (to, from, next) => {
          try {
            await isUserAllowed({ studyId: to.params.studyId });
            const result = await isAssignedToParticipantSite({
              studyId: to.params.studyId,
              participantId: to.params.participantId
            });
            if (result.isAllowed) {
              next();
            } else {
              toastr.error(result.message);
              next(false);
            }
          } catch (error) {
            toastr.error(error.message);
            next(false);
          }
        },
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-form",
        path: ":participantId/forms/:formId",
        component: () => import("../pages/study-participants/study-participant-form"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-activity",
        path: ":participantId/activity/:activityId",
        component: () => import("../pages/study-participants/study-participant-activity"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-survey",
        path: ":participantId/survey/:surveyId/:surveyDate/:trakerId",
        component: () => import("../pages/study-participants/study-participant-survey"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc",
        path: ":participantId/edcForm/:formId/milestone/:milestone/responseId/:responseId",
        component: () => import("../pages/study-participants/study-participant-edcForm.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc-reskin",
        path: ":participantId/edcForm/:formId/milestone/:milestone/responseId/:responseId/:taskInstanceId/reskin",
        component: () => import("../pages/study-participants/study-participant-edcForm-reskin.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc-unschedule-packets",
        path: ":participantId/edcForm/unscheduled",
        component: () => import("../pages/study-participants/study-participant-edc-unscheduled-packets.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc-unschedule-packets-reskin",
        path: ":participantId/edcForm/unscheduled/responseType/:responseType/reskin",
        component: () => import("../pages/study-participants/study-participant-edc-unscheduled-packets-reskin.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc-unschedule-form",
        path: ":participantId/edcForm/unscheduled/:packetId/:unscheduledPacketResponseId",
        component: () => import("../pages/study-participants/study-participant-edc-unscheduled-forms.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc-unschedule-form-reskin",
        path: ":participantId/edcForm/unscheduled/:packetId/:unscheduledPacketResponseId/responseType/:responseType/milestone/:milestone/:taskInstanceId/reskin",
        component: () => import("../pages/study-participants/study-participant-edc-unscheduled-forms-reskin.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-participant-edc-unschedule-packet-reskin",
        path: ":participantId/edcForm/unscheduled/:packetId/:unscheduledPacketResponseId/responseType/:responseType/reskin",
        component: () => import("../pages/study-participants/study-participant-edc-unscheduled-forms-reskin.vue"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "submitted-form",
        path: ":participantId/edcSubmittedForm/:formId/milestone/:milestone/responseId/:responseId",
        component: () => import("../pages/data-capture/edc-submitted-form"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "submitted-form-new",
        path: ":participantId/edcSubmittedForm/:formId/milestone/:milestone/responseId/:responseId/new",
        component: () => import("../pages/data-capture/edc-submitted-form-new"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "submitted-packets-reskin",
        path: ":participantId/edcSubmittedForm/:packetId/responseId/:unscheduledPacketResponseId/responseType/:responseType/milestone/:milestone/:taskInstanceId/reskin",
        component: () => import("../pages/data-capture/edc-submitted-unscheduled-packets-reskin"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "submitted-packets",
        path: ":participantId/edcSubmittedForm/:packetId/responseId/:unscheduledPacketResponseId",
        component: () => import("../pages/data-capture/edc-submitted-unscheduled-packets"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-participant-activity-response-edit",
        path: ":participantId/activity-response",
        component: () => import("../pages/study-participants/study-participants-response-edit"),
        beforeEnter: async (to, from, next) => {
          try {
            await isUserAllowed({ studyId: to.params.studyId });
            const result = await isAssignedToParticipantSite({
              studyId: to.params.studyId,
              participantId: to.params.participantId
            });
            if (result.isAllowed) {
              next();
            } else {
              toastr.error(result.message);
              next(false);
            }
          } catch (error) {
            toastr.error(error.message);
            next(false);
          }
        },
        meta: {
          rule: "*"
        },
        props: true
      }
    ]
  },
  {
    name: "add-edit-participant",
    path: "/studies/:studyId/participants/:participantId",
    component: () => import("../components/participants/add-edit-participant"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "verify-participant",
    path: "/studies/:studyId/:token/:email/verify-participant",
    component: () => import("../components/participants/verify-participant"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "verify-participant-v2",
    path: "/studies/:studyId/:participantId/:token/:email/verify-participant-v2",
    component: () => import("../components/participants/verify-participant-v2"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "verify-participant-v3",
    path: "/studies/:studyId/:participantId/:token/:email/verify-participant-v3",
    component: () => import("../components/participants/verify-participant-v3"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "participant-reset-password",
    path: "/participant-reset-password/:token/:languageId/:lang",
    component: () => import("../components/participants/participant-reset-password"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "study-build-progress",
    path: "/studies/:studyId/study-build-progress",
    component: () => import("../components/configurator/study-build-progress"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "study-design",
    path: "/studies/:studyId/design",
    component: () => import("../components/configurator/design"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "study-customize",
    path: "/studies/:studyId/customize",
    component: () => import("../components/configurator/customize-features"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "features-library",
        path: "library",
        component: () => import("../components/configurator/features-library"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "onboarding",
        path: "onboarding",
        component: () => import("../components/configurator/onboarding"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "branding",
        path: "branding",
        component: () => import("../components/configurator/branding"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activities",
        path: "study-activities",
        component: () => import("../components/configurator/study-activities"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-create-packet",
        path: "study-create-packet",
        component: () => import("../components/configurator/study-activites-packet"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-create-edit-packet",
        path: "packet/:packetId",
        component: () => import("../components/edc-form/create-packet"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "study-schedule-packet",
        path: "study-schedule-packet/:packetId",
        component: () => import("../components/edc-form/schedule-packet"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-form-view",
        path: "study-form-view/:formId",
        component: () => import("../components/edc-form/form-view.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activity-form-view",
        path: "study-activity-form-view/:formId",
        component: () => import("../components/activity-form/activity-form-view.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activity-set-notification",
        path: "study-activity-notification-settings/:formId",
        component: () => import("../components/edc-form/notification-settings"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activity-form-versions",
        path: "study-activity-form-versions/:formId",
        component: () => import("../components/activity-form/activity-form-versions.vue"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-schedule-form",
        path: "study-schedule-form/:formId",
        component: () => import("../components/edc-form/schedule-form"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-activities-configure-new-form",
        path: "/studies/:studyId/configure-new-form/:formId",
        component: () => import("../components/edc-form/configure-new-form"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "eligibility",
        path: "eligibility",
        component: () => import("../components/configurator/eligibility"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "econsent",
        path: "econsent",
        component: () => import("../components/configurator/econsent"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "multieconsent",
        path: "multieconsent",
        component: () => import("../components/configurator/multieconsent"),
        meta: {
          permission: "auth"
        }
      },
      {
        name: "multieconsent",
        path: "multieconsent",
        component: () => import("../components/configurator/multieconsent"),
        meta: {
          permission: "auth"
        }
      },
      {
        name: "epic-mychart",
        path: "epic-mychart",
        component: () => import("../components/configurator/epic-mychart"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "medical-devices",
        path: "medical-devices",
        component: () => import("../components/configurator/medical-devices"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "wearables",
        path: "wearables",
        component: () => import("../components/configurator/wearables"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "engagement-content",
        path: "engagement-content",
        component: () => import("../components/configurator/engagement-content"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "activity-order",
        path: "activity-order",
        component: () => import("../components/configurator/activity-order"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "tele-health",
        path: "tele-health",
        component: () => import("../components/configurator/tele-health"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "tele-health-v2",
        path: "tele-health-v2",
        component: () => import("../components/configurator/tele-health-v2"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "notifications",
        path: "notifications",
        component: () => import("../components/configurator/notifications"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "registration",
        path: "registration",
        component: () => import("../components/configurator/registration"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "health-data-access",
        path: "health-data-access",
        component: () => import("../components/configurator/health-data-access"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "surveys",
        path: "surveys",
        component: () => import("../components/configurator/surveys"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-details",
        path: "surveys/:surveyId/details",
        component: () => import("../components/survey-builder/survey-details"),
        props: true,
        meta: {
          rule: "*"
        }
      },

      {
        name: "survey-template-details",
        path: "surveys/templates/:surveyId/details",
        component: () => import("../components/survey-builder/survey-details"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-instructions",
        path: "surveys/:surveyId/instructions",
        component: () => import("../components/survey-builder/survey-instructions"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-questions",
        path: "surveys/:surveyId/questions",
        component: () => import("../components/survey-builder/survey-questions"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-review",
        path: "surveys/:surveyId/review",
        component: () => import("../components/survey-builder/survey-review"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-scheduler",
        path: "surveys/:surveyId/scheduler",
        component: () => import("../components/survey-builder/survey-scheduler"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "schedule-study-activity",
        path: "study-activities/:surveyId/scheduler",
        component: () => import("../components/activity-library/schedule-study-activity"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-as-template",
        path: "surveys/:surveyId/mark-as-template",
        component: () => import("../components/survey-builder/survey-as-template"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-add-another",
        path: "surveys/:surveyId/add-another-survey",
        component: () => import("../components/survey-builder/survey-add-another"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "dashboards",
        path: "participant-dashboards",
        component: () => import("../components/configurator/participant-dashboards"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epros",
        path: "epros",
        component: () => import("../components/configurator/epros"),
        meta: {
          rule: "*"
        }
      },

      {
        name: "survey-template-details",
        path: "surveys/templates/:surveyId/details",
        component: () => import("../components/survey-builder/survey-details"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-instructions",
        path: "surveys/:surveyId/instructions",
        component: () => import("../components/survey-builder/survey-instructions"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-questions",
        path: "surveys/:surveyId/questions",
        component: () => import("../components/survey-builder/survey-questions"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-review",
        path: "surveys/:surveyId/review",
        component: () => import("../components/survey-builder/survey-review"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-scheduler",
        path: "surveys/:surveyId/scheduler",
        component: () => import("../components/survey-builder/survey-scheduler"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-as-template",
        path: "surveys/:surveyId/mark-as-template",
        component: () => import("../components/survey-builder/survey-as-template"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-add-another",
        path: "surveys/:surveyId/add-another-survey",
        component: () => import("../components/survey-builder/survey-add-another"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "dashboards",
        path: "participant-dashboards",
        component: () => import("../components/configurator/participant-dashboards"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epros",
        path: "epros",
        component: () => import("../components/configurator/epros"),
        meta: {
          rule: "*"
        }
      },

      {
        name: "survey-template-details",
        path: "surveys/templates/:surveyId/details",
        component: () => import("../components/survey-builder/survey-details"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-instructions",
        path: "surveys/:surveyId/instructions",
        component: () => import("../components/survey-builder/survey-instructions"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-questions",
        path: "surveys/:surveyId/questions",
        component: () => import("../components/survey-builder/survey-questions"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-review",
        path: "surveys/:surveyId/review",
        component: () => import("../components/survey-builder/survey-review"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-scheduler",
        path: "surveys/:surveyId/scheduler",
        component: () => import("../components/survey-builder/survey-scheduler"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-as-template",
        path: "surveys/:surveyId/mark-as-template",
        component: () => import("../components/survey-builder/survey-as-template"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "survey-add-another",
        path: "surveys/:surveyId/add-another-survey",
        component: () => import("../components/survey-builder/survey-add-another"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "dashboards",
        path: "participant-dashboards",
        component: () => import("../components/configurator/participant-dashboards"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epros",
        path: "epros",
        component: () => import("../components/configurator/epros"),
        meta: {
          rule: "*"
        }
      },

      {
        name: "epro-create",
        path: "epros/:eproId/create",
        component: () => import("../components/epros/epro-create"),
        props: true,
        meta: {
          rule: "*"
        }
      },
      {
        name: "epro-details",
        path: "epros/:eproId/details",
        component: () => import("../components/epros/epro-details"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epro-validate",
        path: "epros/:eproId/validate",
        component: () => import("../components/epros/epro-validate"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epro-scheduler",
        path: "epros/:surveyId/scheduler",
        component: () => import("../components/epros/epro-scheduler"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epro-add-another",
        path: "epros/:surveyId/add-another-epro",
        component: () => import("../components/epros/epro-add-another"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "epro-create",
        path: "epros/:studyId/epro/create",
        component: () => import("../components/epros/epro-create"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "edros",
        path: "edros",
        component: () => import("../components/configurator/edros"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "edit-edro",
        path: "edit-edro",
        component: () => import("../components/configurator/edit-edro"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "features-library-final",
        path: "features-library-final",
        component: () => import("../components/configurator/features-library-final"),
        meta: {
          rule: "*"
        }
      }
    ]
  },
  {
    name: "review",
    path: "/studies/:studyId/review",
    component: () => import("../components/configurator/review/review"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "study-summary",
        path: "study-summary",
        component: () => import("../components/configurator/review/study-summary"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "scan",
        path: "scan",
        component: () => import("../components/configurator/review/scan"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "generate-prototype",
        path: "generate-prototype",
        component: () => import("../components/configurator/review/generate-prototype"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "study-approval-confirm",
        path: "study-approval-confirm",
        component: () => import("../components/configurator/review/study-approval-confirm"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "documentation",
        path: "documentation",
        component: () => import("../components/configurator/review/documentation"),
        meta: {
          rule: "*"
        }
      },
      {
        name: "approval",
        path: "approval",
        component: () => import("../components/configurator/review/approval"),
        meta: {
          rule: "*"
        }
      }
    ]
  },
  {
    path: "/",
    name: "ssologin",
    component: () => import("../components/auth/ssologin"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "view-video",
    path: "/studies/:studyId/archive/:archiveId/view-video",
    component: () => import("../components/dashboard/view-video"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "study-data-export",
    path: "/studies/:studyId/data-export/:token/resourceId/:resourceId",
    component: () => import("../components/dashboard/download-data-export"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "unsubscribeemail",
    path: "/participants/:participantId/unsubscribeemail",
    component: () => import("../components/participants/unsubscribeemail"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "page-not-found",
    path: "*",
    component: () => import("../components/errors/page-not-found"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "data-export",
    path: "/studies/:studyId/data-export",
    component: () => import("../components/dashboard/data-export"),
    beforeEnter: checkIfUserAllowed,
    meta: {
      rule: "*"
    }
  },
  {
    name: "compliance-report-export",
    path: "/studies/:studyId/compliance-report-export",
    component: () => import("../components/dashboard/data-export"),
    beforeEnter: checkIfUserAllowed,
    meta: {
      rule: "*"
    },
    props: {
      complianceReportData: true
    }
  },
  {
    name: "resource-list-site",
    path: "/studies/:studyId/resource-list-site",
    component: () => import("../components/resource-sites/resource-list"),
    beforeEnter: checkIfUserAllowed,
    meta: {
      rule: "*"
    }
  },
  /** Participants Portal - START */
  {
    name: "participants-portal-web-login",
    path: "/participants/web/login",
    component: () => import("../pages/participants-portal/auth"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "participants-web-sign",
    path: "/participants/web/:clientId/:studyId/country/:countryId/language/:languageId/version/:version",
    component: () => import("../pages/participants-portal/auth"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "participants-web-join",
    path: "/participants/web/:clientId/:studyId/country/:countryId/language/:languageId/version/:version/join",
    component: () => import("../pages/participants-portal/auth"),
    meta: {
      rule: "*"
    }
  },
  {
    name: "participants-auth-login",
    path: "/participants/web/auth",
    component: () => import("../pages/participants-portal/auth"),
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "participants-portal-auth-join",
        path: "join",
        component: () => import("../components/participant-portal/auth/join/index"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participants-portal-auth-location",
        path: "location",
        component: () => import("../components/participant-portal/auth/language-countries"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participants-portal-auth-login",
        path: "login",
        component: () => import("../components/participant-portal/auth/login/index"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participants-portal-auth-registration",
        path: "registration",
        component: () => import("../components/participant-portal/auth/join/registration"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participants-portal-auth-forgot-password",
        path: "forgot-password",
        component: () => import("../components/participant-portal/auth/forgot/password"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participants-portal-auth-forgot-username",
        path: "forgot-username",
        component: () => import("../components/participant-portal/auth/forgot/username"),
        meta: {
          rule: "*"
        },
        props: true
      }
    ]
  },
  {
    name: "participants-portal",
    path: "/participants/web/:studyId",
    component: () => import("../pages/participants-portal/auth"),
    redirect: "/participants/web/:studyId/login",
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "participants-portal-login",
        path: "login",
        component: () => import("../components/participant-portal/auth/login/index"),
        meta: {
          rule: "*"
        },
        props: true
      },
      {
        name: "participants-portal-notifications",
        path: "notification-list",
        component: () => import("../components/participant-portal/notification-list"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "participants-portal-help",
        path: "help",
        component: () => import("../components/participant-portal/help")
      },
      {
        name: "participants-portal-activities",
        path: "activity",
        component: () => import("../components/participant-portal/activity/index"),
        redirect: "/participants/web/:studyId/activity/",
        meta: {
          permission: "auth"
        },
        props: true,
        children: [
          {
            name: "participants-portal-activity-list",
            path: "/",
            component: () => import("../components/participant-portal/activity/activity-list"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-activity-details",
            path: ":taskId",
            component: () => import("../components/participant-portal/activity/activity-details"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-activity-telehealth-details",
            path: ":taskId/telehealth",
            component: () => import("../components/participant-portal/telehealth/index"),
            meta: {
              permission: "auth"
            },
            props: true
          }
        ]
      },
      {
        name: "participants-portal-video-call",
        path: "video-call",
        component: () => import("../components/participant-portal/telehealth/video-call"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "participants-portal-dashboard",
        path: "dashboard",
        component: () => import("../components/participant-portal/dashboard/index"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "participants-portal-learn",
        path: "learn",
        component: () => import("../components/participant-portal/learn/learn"),
        meta: {
          permission: "auth"
        },
        props: true
      },
      {
        name: "participants-portal-profile",
        path: "profile",
        component: () => import("../components/participant-portal/profile/index"),
        meta: {
          permission: "auth"
        },
        props: true,
        children: [
          {
            name: "participants-portal-profile-information",
            path: "information",
            component: () => import("../components/participant-portal/profile/information"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-settings",
            path: "settings",
            component: () => import("../components/participant-portal/profile/settings"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-devices",
            path: "devices",
            component: () => import("../components/participant-portal/profile/devices"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-documents",
            path: "documents",
            component: () => import("../components/participant-portal/profile/documents/index"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-agreement",
            path: "agreement",
            component: () => import("../components/participant-portal/profile/agreement"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-policy",
            path: "privacy-policy",
            component: () => import("../components/participant-portal/profile/privacy-policy"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-license",
            path: "license-information",
            component: () => import("../components/participant-portal/profile/license-information"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-change-password",
            path: "change-password",
            component: () => import("../components/participant-portal/profile/change-password"),
            meta: {
              permission: "auth"
            },
            props: true
          },
          {
            name: "participants-portal-profile-language",
            path: "language",
            component: () => import("../components/participant-portal/profile/language"),
            meta: {
              permission: "auth"
            },
            props: true
          }
        ]
      },
      {
        name: "participants-portal-insight",
        path: "insight",
        component: () => import("../components/participant-portal/insight/index"),
        meta: {
          permission: "auth"
        },
        props: true
      }
    ]
  },
  /** Participants Portal - END */

  // eDro Dashboard.
  {
    name: "eDro",
    path: "/studies/:studyId/eDro",
    component: () => import("../components/visualization"),
    redirect: "/studies/:studyId/eDro/forced-spirometry",
    meta: {
      rule: "*"
    },
    children: [
      {
        name: "edro-forced-spirometry",
        path: "forced-spirometry",
        component: () => import("../components/edro/forced-spirometry"),
        meta: {
          rule: "*"
        }
      }
    ]
  }
];
